import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { WindowRef } from '@shared/services/window-ref/window-ref.service';
import { getConfigClientFromRTE } from '@src/app/core/config/config-client';
import { switchMap, withLatestFrom } from 'rxjs';

import { External, GiftingSummaryContinue } from '../../actions';
import { State } from '../../reducers/index';
import {
  selectAllowedGiftingFlows,
  selectIsGiftingFlowUsingToggle,
} from '../../selectors/triage/triage.selectors';

@Injectable()
export class GiftingSummaryEffects {
  constructor(
    private actions$: Actions,
    private globalStore$: Store<State>,
    private windowRef: WindowRef,
  ) {}

  giftingSummaryContinue$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(GiftingSummaryContinue),
        withLatestFrom(
          this.globalStore$.pipe(select(selectIsGiftingFlowUsingToggle)),
          this.globalStore$.pipe(select(selectAllowedGiftingFlows)),
        ),
        switchMap(([_, isGiftingFlowUsingToggle, allowedGiftingFlows]) => {
          const config = getConfigClientFromRTE();
          const baseHref = this.windowRef.nativeWindow.location.href
            .split('?')[0]
            .slice(0, -'/gifting/summary'.length);
          const cooURL = baseHref + config.gifting_asset_endpoint;
          const intelliDocsURL = config.pretty_ecs_domain + config.giftingIntelliDocs_endpoint;
          const url = isGiftingFlowUsingToggle && allowedGiftingFlows ? cooURL : intelliDocsURL;
          const actions = [];
          actions.push(External({ url: url }));

          return actions;
        }),
      ),
    { dispatch: true },
  );
}

export const effects: any[] = [GiftingSummaryEffects];
